<template>
  <section class="how_to_work__container">
    <h2>Как это работает?</h2>
    <div class="how_to_work__switcher">
      <progress-switcher :items="switcher" />
    </div>
    <div class="cta__container">
      <div class="cta__wrapper">
        <div>
          <p>Оптимизируйте процессы, автоматизируйте задачи и масштабируйте бизнес с Coverse. </p>
          <a target="_blank" :href="signupUrl" class="ui-button-primary mod_rounded-size-s button">
            <span class="desktop">Попробовать прямо сейчас</span>
            <span class="mobile">Попробовать сейчас</span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ProgressSwitcher from "@/components/main/partials/ProgressSwitcher";

export default {
  name: "HowItWork",
  components: {
    ProgressSwitcher
  },
  data() {
    return {
      switcher: [{
        image: 'images/v4/images/how-it-work/image-how-it-works-1@2x.webp',
        title: 'Работа в режиме реального времени',
        text: 'Совместно редактируйте текст и таблицы с видимыми курсорами участников и отображением правок.',
      }, {
        image: 'images/v4/images/how-it-work/image-how-it-works-2@2x.webp',
        title: 'Управление задачами в тексте и таблицах',
        text: 'Оставляйте задачи и комментарии к конкретному фрагменту текста или ячейке таблицы, назначайте ответственного, следите за статусом исполнения на панели задач.',
      }, {
        image: 'images/v4/images/how-it-work/image-how-it-works-3@2x.webp',
        title: 'Безопасный обмен материалами',
        text: 'Встроенные инструменты шеринга на внешние команды и партнёров не требуют сложной регистрация для просмотра.',
      }, {
        image: 'images/v4/images/how-it-work/image-how-it-works-4@2x.webp',
        title: 'Безопасное хранение данных в&nbsp;РФ',
        text: 'Все данные хранятся в РФ, с соблюдением законодательства и гарантией непрерывной доступности.',
      }, {
        image: 'images/v4/images/how-it-work/image-how-it-works-5@2x.webp',
        title: 'Доступ без VPN',
        text: 'Не нужен VPN для обхода блокировок и нарушения корпоративных политик: сервис работает на отечественном сервере.',
      }],
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/breakpoints";
@import "@/styles/button-primary.scss";

.how_to_work__container {
  max-width: 1000px;
  margin: 0 auto;

  h2 {
    font-size: 40px;
    font-weight: 700;
    line-height: 40px;
    text-align: center;
    margin: 0 0 45px;
  }

  .how_to_work__switcher {
    min-height: 410px;
  }

  .cta__container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 90px auto 0;
    padding: 0 0 70px 0;

    .cta__wrapper {
      display: flex;
      max-width: 800px;
      width: 100%;
      height: 240px;
      border-radius: 20px;
      padding: 50px 60px;
      overflow: hidden;
      background-image: url('/images/v4/images/how-it-work/image-cta-2@2x.webp');
      background-size: cover;
      background-repeat: no-repeat;

      div {
        position: relative;
        width: 100%;
        flex: 1 0 auto;
      }
    }

    p {
      max-width: 540px;
      font-size: 20px;
      font-weight: 600;
      line-height: 34px;
      color: #ffffff;
      margin: 0;
    }

    .button {
      width: 290px;
      position: absolute;
      right: 0;
      bottom: 0;
      font-size: 17px;
      color: #333334;
      background-color: #ffffff;

      .mobile {
        display: none;
      }
    }
  }
}

@include media-breakpoint-down($size-tablet) {
  .how_to_work__container {
    padding: 0 30px;

    h2 {
      font-size: 34px;
      margin: 0 0 38px;
    }

    .how_to_work__switcher {
      max-width: 500px;
      margin: 0 auto;
    }

    .cta__container {
      margin: 70px auto 0;

      .cta__wrapper {
        padding: 50px 30px;
      }
    }
  }
}

@include media-breakpoint-down($size-mobile) {
  .how_to_work__container {
    padding: 0 20px;

    h2 {
      font-size: 24px;
      line-height: 34px;
      margin: 0 0 27px;
    }

    .cta__container {
      padding: 0 0 55px;
      margin: 55px auto 0;

      .cta__wrapper {
        height: 260px;
        padding: 50px 15px 42px;
        background-position: 65%;
      }

      p {
        font-size: 16px;
        line-height: 26px;
        text-align: center;
      }

      .button {
        width: 100%;
        height: 40px;
        font-size: 17px;
        line-height: 40px;

        .desktop {
          display: none;
        }

        .mobile {
          display: inline;
        }
      }
    }
  }
}
</style>
